import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxSpinnerService } from "ngx-spinner";
import { CloudTypes, NodeTypes } from "../../../../core/models/globals";
import { NodeService } from "../../../../core/services/node.service";
import {
  AttachNodeAction,
  MultiNodeActionDTO,
  Node,
} from "src/app/core/models/node";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-attach-node",
  templateUrl: "./attach-node.component.html",
  styleUrls: ["./attach-node.component.scss"],
})
export class AttachNodeComponent implements OnInit {
  attachNodeForm: UntypedFormGroup = new UntypedFormGroup({});
  isFormSubmitted;
  nodes: Node[];
  filteredWorkstations: Node[];
  multiSelectIndex = [];
  isSelectAll: boolean = false;
  depName;
  alreadyAttachedNodes = [];
  filterText: string = "";
  filtersApplied: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialogRef<AttachNodeComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      depName: string;
      cloudType: string;
      wsAttached: Node[];
      connectorType: string;
      hostVmId: string;
    },
    public nodeService: NodeService,
    private _spinner: NgxSpinnerService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this._spinner.show("attachNode");
    this.depName = this.data.depName;
    if (this.data.wsAttached) {
      this.data.wsAttached.forEach((x) => {
        this.alreadyAttachedNodes.push(x.vmName);
      });
    }
    this.nodeService.getAllWorkstations().subscribe({
      next: (data) => {
        this.nodes = JSON.parse(JSON.stringify(data));
        var uniqueNodes = [];
        if (this.nodes) {
          if (this.data.hostVmId || this.data.hostVmId != null) {
            this.nodes.forEach((x) => {
              if (x.hostNodeVmId == this.data.hostVmId) {
                this.multiSelectIndex.push(x.vmName);
              }
              if (
                (x.hostNodeVmId == null ||
                  x.hostNodeVmId == this.data.hostVmId) &&
                x.nodeType == NodeTypes.TxtWorkstation
              ) {
                uniqueNodes.push(x);
              }
              else {
                if (x.nodeType == NodeTypes.TxtWorkstation && x.hostNodeVmId != null) {
                  uniqueNodes.push(x);
                }
              }
              return null;
            });
          } else {
            this.nodes.forEach((x) => {
              if (
                x.nodeType == NodeTypes.TxtWorkstation &&
                !this.alreadyAttachedNodes.includes(x.vmName) &&
                (this.data.connectorType?.toLowerCase() ==
                  x.connectorType?.toLowerCase() ||
                  (x.connectorType == CloudTypes.KVM &&
                    this.data.connectorType == CloudTypes.OnPremise))
              ) {
                uniqueNodes.push(x);
              }
              this._spinner.hide("attachNode");
              return null;
            });
          }
        } else {
          this._spinner.hide("attachNode");
        }

        this.nodes = uniqueNodes.sort(
          (a, b) =>
            0 - (b.vmName.toLowerCase() < a.vmName.toLowerCase() ? -1 : 1)
        );
        this.filteredWorkstations = this.nodes;
        this._spinner.hide("attachNode");
      },
      error: (err) => {
        this._spinner.hide("attachNode");
      },
    });
  }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit(form) {
    if (this.data.hostVmId == null) {
      if (this.multiSelectIndex.length == 0) {
        this._snackBar.open("Select node(s) to perform action", "Ok", {
          duration: 5000,
        });
        return;
      }
    }

    if (this.data.hostVmId == null) {
      let wsObj: MultiNodeActionDTO = {
        attachObj: null,
        detachObj: null,
      };

      /*let wsNames = this.nodes.filter((nd, i) => { return this.multiSelectIndex.includes(i) })
        .map(nd => { return nd.vmName });*/

      let wsNames = this.multiSelectIndex;

      wsObj.attachObj = {
        deploymentNames: this.depName,
        wsNames: wsNames.toString(),
      };
      this.nodeService.multiNodeAction(5, wsObj).subscribe({
        next: (data: any) => {
          this._snackBar.open(
            data?.actionMessage || data?.body?.actionMessage,
            "Ok",
            { duration: 5000 }
          );
          this.multiSelectIndex = [];

          this.dialog.close(true);
        },
        error: (err) => {
          this._snackBar.open(err?.error?.actionMessage, "Ok", {
            duration: 5000,
          });
          this.dialog.close(true);
        },
      });
    } else {
      let wsNames;
      if (this.multiSelectIndex?.length > 0) {
        wsNames = this.multiSelectIndex?.toString();
      } else {
        wsNames = null;
      }
      this.nodeService
        .assignHostNodeVmId(this.data.hostVmId, wsNames)
        .subscribe({
          next: (data: any) => {
            this._snackBar.open(data?.successMessage, "Ok", { duration: 5000 });
            this.dialog.close(true);
          },
          error: (err) => {
            this._snackBar.open(err?.error?.successMessage, "Ok", {
              duration: 5000,
            });
            this.dialog.close(true);
          },
        });
    }
  }

  onSelectAllCheckBox(event) {
    let filteredNodes = this.applyFilter();
    if (event.target.checked) {
      filteredNodes?.forEach((node, i) => {
        if (!this.multiSelectIndex.includes(node.vmName)) {
          this.multiSelectIndex.push(node.vmName);
        }
      });
      if (filteredNodes?.length == this.nodes.length) {
        this.isSelectAll = true;
      }
      return;
    } else {
      filteredNodes?.forEach((node, i) => {
        if (this.multiSelectIndex.includes(node.vmName)) {
          let index = this.multiSelectIndex.indexOf(node.vmName);
          if (index !== -1) {
            this.multiSelectIndex.splice(index, 1);
          }
        }
      });
      if (filteredNodes?.length == this.nodes.length) {
        this.isSelectAll = false;
      }
      return;
    }
  }

  checkSelectedCheckboxes(event, nodeName) {
    /*if (!this.multiSelectIndex.includes(i)) {
      this.multiSelectIndex.push(i)
      if (this.multiSelectIndex.length == this.nodes.length) {
        this.isSelectAll = true
      }
    }
    else {
      let idx = this.multiSelectIndex.indexOf(i)
      this.multiSelectIndex.splice(idx, 1)
      if (this.multiSelectIndex.length == 0 || this.multiSelectIndex.length != this.nodes.length) {
        this.isSelectAll = false
      }
    }*/
    if (event.target.checked) {
      if (!this.multiSelectIndex.includes(nodeName)) {
        this.multiSelectIndex.push(nodeName);
        if (this.multiSelectIndex.length == this.nodes.length) {
          this.isSelectAll = true;
        }
      }
    } else {
      let idx = this.multiSelectIndex.indexOf(nodeName);
      this.multiSelectIndex.splice(idx, 1);
      if (
        this.multiSelectIndex.length == 0 ||
        this.multiSelectIndex.length != this.nodes.length
      ) {
        this.isSelectAll = false;
      }
    }
  }

  applyFilter() {
    this.filtersApplied = true;
    this.filteredWorkstations = this.nodes;
    if (this.filterText != "") {
      this.filteredWorkstations = this.filteredWorkstations.filter((nd) =>
        nd.vmName.toLowerCase().includes(this.filterText.toLowerCase())
      );
    }
    return this.filteredWorkstations;
  }
}
